export const selectAntihomotoxicos = (state) =>
  state.holonmed.antihomotoxicos || [];
